export const BAR_MAX_WIDTH = 60
export const HOVER_SCALE_FACTOR = 1.3
export const DEFAULT_BORDER_RADIUS = 5
export const BAR_WIDTH_ADJUSTMENT = 0.3
